const { sumCounts, keySkuSupplier, qtyRtv, aggregateQuantitiesBySku, updateCountsFromSkuQuantities } = require('../utils')

function createReturnToSupplier ({ mainApi, batches }) {
  return async function returnToSupplier (params = {}) {
    const {
      warehouse: warehouseCode,
      supplier_id: supplierUuid,
      rtv_date: rtvDate
    } = params

    if (!Array.isArray(params.items) || params.items.length === 0) {
      const err = new Error('returnToSupplier: items missing')
      err.status = 400
      throw err
    }

    if (!warehouseCode) {
      const err = new Error('returnToSupplier: warehouse is required')
      err.status = 400
      throw err
    }

    if (!supplierUuid) {
      const err = new Error('returnToSupplier: supplier_id is required')
      err.status = 400
      throw err
    }

    let warehouse
    try {
      warehouse = await mainApi.location.pgAdapter.getOneByCode(warehouseCode)
    } catch (err) {
      const error = new Error(`returnToSupplier: warehouse not found for code: ${warehouseCode}`)
      error.status = 404
      throw error
    }
    if (!warehouse || !warehouse.fsid) {
      const err = new Error(`returnToSupplier: warehouse missing for code: ${warehouseCode}`)
      err.status = 404
      throw err
    }

    let supplier
    try {
      supplier = await mainApi.location.pgAdapter.getOne(
        supplierUuid,
        { whereCondition: 'uuid' }
      )
    } catch (err) {
      const error = new Error(`returnToSupplier: supplier not found for uuid: ${supplierUuid}`)
      error.status = err.status || 404
      throw error
    }
    if (!supplier || !supplier.fsid) {
      const err = new Error(`returnToSupplier: supplier missing for uuid: ${supplierUuid}`)
      err.status = 404
      throw err
    }

    // Persist batches from RTV payload so downstream syncs can fetch real expiry dates.
    await batches.fromRtv(params.items)

    const baseCounts = sumCounts(params.items, {
      nested: false,
      key: (it) => keySkuSupplier(it.sku_code, 'unknown'),
      qty: qtyRtv,
      enforceNonNull: true
    })

    const skuBatchQuantities = aggregateQuantitiesBySku(
      params.items,
      item => item && item.rtv_quantity,
      {
        getBatchEntries: (item) => {
          if (!item) return []
          return [{
            batchNumber: item.batch_no,
            quantity: item.rtv_quantity
          }]
        }
      }
    )

    const countsWithBatches = updateCountsFromSkuQuantities(baseCounts, skuBatchQuantities)

    const counts = Object.entries(countsWithBatches).reduce((acc, [key, entry]) => {
      acc[key] = { ...entry, checked: true }
      return acc
    }, {})

    const normalizedDate = new Date(rtvDate).toJSON().split('T')[0]
    const [snapshotData] = await mainApi.shipment.decorateShipmentSnapshotsWithResolvedPrices([{
      origin: warehouse.fsid,
      destination: supplier.fsid,
      date: normalizedDate,
      status: 'received',
      doCheckSent: false,
      counts
    }])
    return mainApi.shipment.createSnapshot(snapshotData)
  }
}

module.exports = createReturnToSupplier
